import comp from "./WorkbookTemplateWrapper";
export default comp;
